import { takeEvery } from 'redux-saga/effects';
import openSocket from 'socket.io-client';
import getStore from '../index';

import { appConstants } from '../constants';
import { getLiveCasino } from '../selectors/liveCasinoData';
import { appInitialized, subscribed, unsubscribed } from '../actions/app';
import { profile } from '../../../casino/store/actions/actionTypes';
import { tablesStateIni, tablesStateUpdate } from '../actions/tables';
import config from '../../api/config';

let socket = null;
let initialized = false;

export const connect = () => {
  if (socket !== null) {
    return;
  }

  const query = {
    protocol: 'sio1',
  };

  if (window.config && window.config.clientId) {
    query['tenantId'] = window.config.clientId;
  }

  socket = openSocket(config.wsUrl, {
    path: '/evolution/ws',
    forceNew: true,
    transports: ['websocket'],
    allowEIO3: true,
    query,
  });

  //console.log("app socket", socket);

  socket.on('connect', () => {
    //console.log("Evolution App socket connected");
  });

  socket.on('event', function (data) {
    //console.log("Evolution Socket event data", data);
  });

  socket.on('error', (error) => {
    console.log('Evolution Socket error', error);
  });

  socket.on('connect_error', (error) => {
    console.log('Evolution Socket connect error', error);
  });

  socket.on('state', (data) => {
    getStore().dispatch(tablesStateIni(data));
  });
  socket.on('state-update', (data) => {
    getStore().dispatch(tablesStateUpdate(data));
  });
};

export const appDisconnect = () => {
  if (socket !== null) {
    socket.disconnect();
    socket = null;
  }
};

function* appInitializeSaga() {
  const evo = getLiveCasino(getStore().getState());

  if (window.config.disableGuestWebsocket === '1') {
    const { authentication } = getStore().getState();
    if (!(authentication && ['user', 'token'].indexOf(authentication.auth_type) > -1)) {
      return;
    }
  }

  if (!evo.app.initialized) {
    if (socket === null) yield connect();
    if (!initialized) yield getStore().dispatch(appInitialized());
  }
}

function* appSubscribeSaga() {
  //console.log("subscribe to evolution events");
  if (socket !== null) {
    try {
      const evo = getLiveCasino(getStore().getState());
      if (!evo.app.subscribed) {
        yield socket.emit('subscribe', 'evolution');
        yield getStore().dispatch(subscribed());
      }
    } catch (err) {
      //console.log("appSubscribeSaga", err, socket);
    }
  }
}

function* appUnsubscribeSaga() {
  //console.log("unsubscribe from evolution events");
  if (socket !== null) {
    try {
      const evo = getLiveCasino(getStore().getState());
      if (!evo.app.subscribed) {
        yield socket.emit('unsubscribe', 'evolution');
        yield getStore().dispatch(unsubscribed());
      }
    } catch (err) {
      //console.log("appUnsubscribeSaga", err, socket);
    }
  }
}

export default function* watchAppSaga() {
  //console.log("watching evolution app");
  yield takeEvery(appConstants.INITIALIZE, appInitializeSaga);
  yield takeEvery(appConstants.SUBSCRIBE, appSubscribeSaga);
  yield takeEvery(appConstants.UNSUBSCRIBE, appUnsubscribeSaga);
  if (window.config.disableGuestWebsocket === '1') {
    yield takeEvery(profile.RECEIVED_ACCOUNT, appInitializeSaga);
  }
}
